@import "~animatewithsass/animate.scss";
@import '~loaders.css/src/animations/ball-pulse.scss';

@mixin button-save {
  background: linear-gradient(0deg, #006755, #00B89B);
  border: inherit;
  border-radius: 5px;
  box-shadow: 0 3px 3px black;
  outline: none;
}

@mixin drop-down {
  position: absolute;
  right: -20px;
  z-index: 1;
}

.container-fluid {

  .file {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    text-align: center;
    left: 0;
    .upload {
      box-shadow: 0 0 10px white;
      width: 60%;
      height: 300px;
      top: 30%;
      position: relative;
      display: table;
      margin: 0 auto;
      padding-top: 80px;
      border: 2px dashed #161C1F;
      .cancel{
        position: absolute;
        right: 10px;
        top: 10px;
        .fa-times{
          -webkit-text-stroke: 2px inherit;
          font-size: 16px;
          border: 2px solid;
          border-radius: 30px;
          padding: 4px 5px 4px 5px;
          cursor: pointer;
          &:hover{
            font-size: 20px;
            transition: font-size .15s ease;
          }
        }
      }
    }
    .btn-file {
      border: none;
      outline: none;
      color: white
    }
  }

  .display-true {
    display: block;
  }

  .display-false {
    display: none;
  }

  .blur-true {
    filter: blur(5px);
    position: fixed;
    width: 100%;
  }

  .blur-false {
    filter: none;
    transition: filter 1s ease;
  }

  .btn-save {
    @include button-save;
    position: absolute;
    right: 60px;
  }

  .btn-menu {
    position: absolute;
    right: 0;
    background-color: transparent;
    color: white;
    outline: none;
    padding: 0 10px;
    cursor: pointer;
    .dots {
      font-size: 30px;
      letter-spacing: 3px;
    }
  }

  .select-dropdown {
    margin-top: 70px;
    @include drop-down;
  }

  .select-dropdown-true {
    @include fadeInDown($duration: .5s,
    $delay: 0s,
    $function: ease,
    $fill: both);
  }

  .select-dropdown-false {
    visibility: hidden;
    @include fadeOutUp($duration: .5s,
    $delay: 0s,
    $function: ease,
    $fill: both);
    transition: all .5s ease;
  }

  .main {
    padding: 25px 0;
    //margin-top: -1px;
    //max-width: 1300px;
    margin-right: auto;
    margin-left: auto;
    .mobile-save-block {
      display: flex;
      float: right;
      .btn-save-mobile {
        @include button-save;
      }
      .btn-menu-mobile {
        background-color: transparent;
        color: white;
        outline: none;
        padding: 0 10px;
        cursor: pointer;
        .dots {
          font-size: 30px;
          letter-spacing: 3px;
          margin-top: -12px;
        }
      }
      .select-dropdown-mobile {
        margin-top: 15px;
        @include drop-down;
      }
    }
    .btn-mobile {
      color: white;
      outline: none;
      box-shadow: 0 2px 2px black;
      border: none;
    }
    .links {
      //width: 12%;
      padding-right: 0;
      padding-left: 0;
     // height:76vh !important;
      @media (min-height: 1350px){
        height: 85vh !important;
      }
    }
    .main-content {
      display: table;
      .mobile-links {
        position: absolute;
        z-index: 1;
        height: 100% !important;
        width: 40% !important;
      }
      .mobile-links-true {
        @include fadeInLeftBig($duration: 2s,
        $delay: -1.3s,
        $function: ease,
        $fill: forward);
      }
      .mobile-links-false {
        @include fadeOutLeftBig($duration: 6s,
        $delay: 0s,
        $function: ease,
        $fill: both);
      }
      .mobile-routes {
        .container-fluid-editor {
          border-radius: 10px !important;
        }
        .container-fluid-category {
          border-radius: 10px !important;
        }
        .container-fluid-flags {
          border-radius: 10px !important;
        }
        .container-fluid-settings {
          border-radius: 10px !important;
        }
        .container-fluid-machine-settings{
          border-radius: 10px !important;
        }
        .container-fluid-display-and-keyboard{
          border-radius: 10px !important;
        }
        .container-fluid-hardware-setup{
          border-radius: 10px !important;
        }
        .container-fluid-miscellaneous{
          border-radius: 10px !important;
        }
      }
      .links {
        border-right: 0 !important;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }
      .links, .routes {
        height:100%;
        float: none;
        display: table-cell;
        vertical-align: top;
      }
    }
  }
  @media (min-width: 767px) and (max-width: 1025px) {
    .links{
      width:15% !important;
    }
  }

  @media (max-width: 767px) {
    .links{
      width:auto !important;
    }
  }

  .border-top{
    margin-top: -1px;
  }
}

.root-app {
  .settings-tab {
    width: 195px !important;
    margin: 0 auto 0 0 !important;
    text-transform: none !important;
  }
  .recipe-tab {
    width: 195px !important;
    margin: 0 0 0 auto !important;
    text-transform: none !important;
  }
  .error-view{
    display: flex !important;
    .modal-dialog {
      width: 500px;
      margin: auto;
      .modal-content {
        border: 2px solid #3C4756;
        border-radius: 7px;
        @include bounceIn();
        .modal-header {
          background: #262F39;
          color: #C1CAD6;
          text-align: center;
          padding-top: 0;
          padding-bottom: 0;
          border-bottom: 0;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          .modal-title {
          }
        }
        .modal-body {
          background: #1D232C;
          .text {
            padding:18%;
            text-align: center;
            color: #8491A2;
            font-size: 20px;
            font-weight: 100;
            font-family: "Solomon_Normal";
          }
        }
        .modal-footer {
          border-top: 0;
          background: #262F39;
          color: whitesmoke;
          text-align: center;
          cursor: pointer;
          border-bottom-right-radius: 5px;
          border-bottom-left-radius: 5px;
          padding-top: 9px;
          padding-bottom: 9px;
        }
      }
    }
  }

  @media (max-width: 543px) {
    .settings-tab, .recipe-tab {
      width: 50% !important;
      margin: 0 !important;
    }
  }
}

.content-container {
  height:100% !important;
  .h-100{
    height:100% !important;
  }
}

.content-container > div:first-child{
    height:100% ;
}

.app-loader{
  position: fixed;
  left: 50%;
  top: 50%;
}

.loader-hidden {
  display: none;
}
.loader-active {
  display: block;
}

@media (min-width: 1400px) {
  .main{
    max-width: 1100px;
  }
  .links {
    width: 14%;
  }
}

@media (min-width: 1025px) and (max-width: 1400px){
  .links {
    width: 12% !important;
  }
}



// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/app.scss